import PropTypes from 'prop-types'

export const appFormPropTypes = {
  formik: PropTypes.shape({
    setFieldValue: PropTypes.func.isRequired,
    touched: PropTypes.object,
    validateForm: PropTypes.func.isRequired,
    values: PropTypes.shape({
      currentConnector: PropTypes.shape({
        clientCredential: PropTypes.shape({
          clientId: PropTypes.string,
          clientSecret: PropTypes.string
        }),
        iconUrl: PropTypes.string,
        id: PropTypes.string,
        name: PropTypes.string,
        type: PropTypes.string,
        webHookUrl: PropTypes.string,
        appId: PropTypes.string
      })
    })
  })
}
